<template>
    <div class="col-12 col-lg-6 reg-size-form pt-3 pb-4 mt-0 mt-lg-4">
        <div v-if="showTitle || showSubTitle">
            <h1 class="h2 mb-2 mb-sm-3 fw-light" v-if="showTitle">Sustainable journeys <span class="fw-bold">begin here</span></h1>
            <p class="mb-2" v-if="showSubTitle">Order the right tyres for your vehicle using your registration</p>
        </div>
        <reg-form :postcode="postcode" :image-base-path="imageBasePath" :brand="brand"></reg-form>
        <p class="pt-3">Or enter tyre size</p>
        <size-form :postcode="postcode" :options="options" :brand="brand"></size-form>
        <a :href="this.baseUrl + '/tyre-info'" class="text-secondary w-auto text-underline small" target="_blank" title="Where do i find my tyre size?">Where do I find my tyre size?</a>
    </div>
</template>

<script>
    export default {
        props: ['options', 'postcode', 'imageBasePath', 'showTitle', 'showSubTitle', 'brand'],
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }
        },
        methods: {

        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';

    .reg-size-form {
        background: #fff;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 18px;
        z-index: 10;
        @media screen and (min-width: 992px) {
            max-width: 570px;
            max-height: 355px;
        }
        .sub-heading, h3 {
            text-align: left;
            font-size: 16px;
        }
        button {
            p {
                font-weight: 400;
            }
        }
    }
</style>